export const MAX_PERCENTAGE_ALLOWED = 999
